<template>
    <div id="skills" class="mx-auto lg:w-9/12 w-10/12 py-12">
        <h2 class="text-xl font-medium tracking-widest text-gray-400">TECH SKILLS</h2>
        <div class="mt-5 flex flex-wrap gap-4">
            <span v-for="(skill, index) in skills" :key="index" class="py-1 px-4 border hover:bg-indigo-500 hover:text-white border-indigo-500 text-indigo-500 rounded-full">{{ skill }}</span>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            skills: [
                'HTML', 'CSS', 'JavaScript', 'JQuery', 'PHP', 'Node Js', 'Laravel', 'Vue Js', 'Tailwind', 'Bootstrap', 'Quasar',
                'MySQL', 'MongoDB', 'Firebase', 'AWS', 'Digital Ocean', 'Git', 'WebRTC', 'WebSocket', 'Dialogflow'
            ]
        }
    }
}
</script>

<style scoped>
    .timeline{
        left: 6.5px;
        height: calc(100% - 18px)
    }
</style>